import ManagementDDL from '../../views/ManagementDDL';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../../../state/assessment';

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  projectList: state.shift.assessment.RepositoryNameList,
  groupId: state.shift.auth.groupId,
  gitlab_id: state.shift.auth.gitlab_id,
  reference_id: state.shift.assessment.reference_id,
  clientname: state.shift.assessment.clientname,
  opportunity_num: state.shift.assessment.opportunity_num,
  financialforce_id:state.shift.assessment.financialforce_id,
  srclang: state.shift.assessment.srclang,
  tgtlang: state.shift.assessment.tgtlang,
  description: state.shift.assessment.description,
  popwindow: state.shift.status.popwindow,
  role: state.shift.auth.role,
  flag:state.shift.assessment.flag,
  username: state.shift.auth.username,
  customersList:state.shift.assessment.customersList,
  customerprojectList:state.shift.assessment.customerprojectList,
  stagingprojectList:state.shift.assessment.stagingprojectList,
  filesList: state.shift.assessment.filesList,
  customerid: state.shift.auth.customerid,
});
const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    transSubmitHandler: reponame => {
      dispatch(actions.savetranslation(reponame));
    },

    getinfobyponumber: event => {
      dispatch(actions.getinfobyponumber({ value: event.target.value }.value));
    },

    getinfobyreponame: event => {

    const old_clientname = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'];
    const old_financialforce_id = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['financialforce_id'];//['opportunity_num'];
    const old_srclang = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'];


    dispatch(actions.getinfobyreponame({ value: event.target.value }.value));


    function disableButton(){
        const new_clientname = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'];
        const new_financialforce_id = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['financialforce_id'];  //['opportunity_num'];
        const new_srclang = JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'];

        setTimeout(() => {
            if(old_clientname != new_clientname && new_clientname!=null){
              dispatch(actions.setflag(new_clientname.length==0));
                return;
              }

           if(old_clientname != new_clientname && new_clientname == null ){
              dispatch(actions.setflag(true));
              return;

           }

            // if(new_opp_num != null  && old_opp_num != new_opp_num){
            //               dispatch(actions.setflag(new_opp_num.length==0));
            //                 return;
            //  }

             if(new_financialforce_id != ''  && old_financialforce_id != new_financialforce_id){
              dispatch(actions.setflag(new_financialforce_id.length==0));
                return;
             }

            //  if(old_opp_num != new_opp_num && new_opp_num == null){
            //     dispatch(actions.setflag(true));
            //     return;
            //  }

             if(old_financialforce_id != new_financialforce_id && (new_financialforce_id == null || new_financialforce_id == '')){
              dispatch(actions.setflag(true));
              return;
           }

           if(new_financialforce_id == ''){

            if (JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['financialforce_id'] != undefined
             && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['financialforce_id'] != null
              && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['financialforce_id'].length>0){
                    dispatch(actions.setflag(false));
            }else{

              dispatch(actions.setflag(true));
            }

            return;
         }

             if(old_srclang  != new_srclang &&  new_srclang == null ){
              dispatch(actions.setflag( true));
               return;
            }
             if(old_srclang  != new_srclang  ){
                  dispatch(actions.setflag( new_srclang ==''));
                return;
             }


        disableButton ();
        }, 500);
        }
        disableButton ();
        },

    desHandlerHandler: event => {
      dispatch(actions.changeds({ value: event.target.value }.value));
    },

    srcChangeHandlerHandler: event => {
      dispatch(actions.changesrc({ value: event.target.value }.value));
      if (JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'] !=null
        && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'].length>0
        &&  JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['financialforce_id'] != null
        && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['financialforce_id'].length>0
          ){
               dispatch(actions.setflag(false));
          }
    },

    oppnumChangeHandler: event => {
      dispatch(actions.changefinid({ value: event.target.value }.value));

      if (JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'] !=null
        && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['clientname'].length>0
        && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'] !=null
          && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'] != ""
      ){
           dispatch(actions.setflag(false));
      }

      if( JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['financialforce_id'] != null
       && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['financialforce_id'].length==0){

       }
    },

    clientnameChangeHandler:event => {

      dispatch(actions.changeclientname({ value: event.target.value }.value));
      if (  JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['financialforce_id']!= undefined
      && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['financialforce_id']!=''  //null
      && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['financialforce_id'].length>0
      && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'] !=null
      && JSON.parse(JSON.parse(sessionStorage.getItem("persist:shift"))['assessment'])['srclang'] != ""
      ){
        dispatch(actions.setflag(false));
       }

    },

    clickBackHandler: value => {
      dispatch(push(`/${locale}/shift`));
    },

    customersPrjList: (jobtype,customerid)=>{
      dispatch(actions.customersPrjList(jobtype,customerid)).then(data=> data);
    },

    getCustomers: ()=>{
      dispatch(actions.customersList());
    },

    // gitlabProjects: (customerid) => dispatch(actions.projectsList('Translation', customerid)),

    clickSubmitHandler: (
      username,
      reponame,
      srclang,
      tgtlang,
      description,
      jobType,
      reponamefordataen,
      customerid,
      projectname,
      fun
    ) => {
      dispatch(
        actions.translationworking(
          username,
          reponame,
          srclang,
          tgtlang,
          description,
          jobType,
          reponamefordataen,
          customerid,
          projectname,
        )
      ).then((e) => fun(e))
    },

    docheckddlexist: (customerid,projectname,page,fun) => {
      console.log(customerid)
      // alert(customerid);
      // alert(projectname);
      dispatch(actions.checkddlexist(customerid,projectname,'DDLPage')).then(
        res => {
        if(res.value.code == "200"){
         
          fun(false);
        
        }
      }
      );
    },


    getinfobyreponameforaccessment: (value,customerid,jobtype,fun) => {
      console.log(customerid)
      dispatch(actions.getinfobyreponame(value,customerid,jobtype)).then(
        (e)=> fun(e)
      );
    },

    getStagingPrjList: (jobtype,repo,customerid)=>{
      dispatch(actions.stagingPrjList(jobtype,repo,customerid));
    },

    getfilesList: (groupid,customerid)=>{
      dispatch(actions.filesList(groupid,customerid));
    },

    resetCustomersPrjList : ()=>{
      dispatch(actions.resetCustomersPrjList());
    },

    resetStagingPrjList : ()=>{
      dispatch(actions.resetStagingPrjList());
    },

    userRequest: (
      username,
      reponame,
      srclang,
      tgtlang,
      description,
      jobType,
      customerid,
      showMessageTrue)=>{

      dispatch(actions.userRequest(
        username,
        reponame,
        srclang,
        tgtlang,
        description,
        jobType,
        customerid)).then((e)=> {
          showMessageTrue(e)
        }
      );
    }
  };
};

const ManagementDDLComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagementDDL);

export default ManagementDDLComponent;



// WEBPACK FOOTER //
// ./src/components/container/ManagementDDL/index.js